export var Name = 'cancel-subscription';
export var CancelSubscriptionEvent = Name;